import { db } from '../../config/firebaseconfig'

// Gets all of the district records with matching geographic state 
// initials, for example "CA" or "GA"
export default function getAllDistrictsInState (geoState) {
  return db.collection('districts').where('state', '==', geoState).get()
    .then(querySnapshot => {
      let districts = []
      querySnapshot.forEach(doc => {
        if (doc.exists) {
          const data = doc.data()
          if (!data.deleted) {
            districts.push(data)
          }
        }
      })
      return districts
    })
}


// WEBPACK FOOTER //
// ./src/helpers/users/getAllDistrictsInState.js